const CouponIcon = ({ stroke, ...props }) => (
  <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M35.4736 13.8574V17.8574M35.4736 27.1908V37.8574M35.4736 47.1908V51.1908"
      stroke="#2E3860"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.8066 16.5241V48.5241C56.8066 49.2313 56.5257 49.9096 56.0256 50.4097C55.5255 50.9098 54.8472 51.1908 54.14 51.1908H11.4733C10.7661 51.1908 10.0878 50.9098 9.58769 50.4097C9.08759 49.9096 8.80664 49.2313 8.80664 48.5241V40.5241C10.9284 40.5241 12.9632 39.6812 14.4635 38.1809C15.9638 36.6807 16.8066 34.6458 16.8066 32.5241C16.8066 30.4024 15.9638 28.3675 14.4635 26.8672C12.9632 25.3669 10.9284 24.5241 8.80664 24.5241V16.5241C8.80664 15.8168 9.08759 15.1386 9.58769 14.6385C10.0878 14.1384 10.7661 13.8574 11.4733 13.8574H54.14C54.8472 13.8574 55.5255 14.1384 56.0256 14.6385C56.5257 15.1386 56.8066 15.8168 56.8066 16.5241Z"
      stroke="#2E3860"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CouponIcon;
